import React from "react";
import Education from "./Education/Education";
import Experience from "./Experience/Experience";

const About = () => {
  return (
    <div className=" w-full px-5 md:px-20  mx-auto py-2">
        <div className="flex items-center justify-center my-4 space-x-4">
          {/* <h6 className=" text-lg text-white">MY</h6> */}
          <h6 className="text-green-500 font-bold font-roboto text-3xl ">
            &lt; About / &gt;
          </h6>
        </div>
        <div className="flex w-full justify-center items-center">
          <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
          <span className="mx-2"></span>
          <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
          <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
          <span className="mx-2"></span>
          <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
          <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
          <span className="mx-2"></span>
          <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
          <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
          <span className="mx-2"></span>
          <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
        </div>
        {/* <div className="text-white text-center text-[18px] font-roboto md:pt-8">
            Jawad here! I live in Bangladesh. 
        </div> */}
        <div className="w-full my-0 mx-auto md:flex pt-0 md:space-x-20 space-x-0  md:pt-8  md:space-y-0 md:flex-row justify-center items-center md:items-start">
            <Education classes={"w-[100%] xl:px-20 mb-14 md:mb-0 mt-10 md:mt-0"}></Education>
            <div className="w-[2px] h-[300px] bg-white hidden md:block">

            </div>
            <Experience classes={"w-[100%] xl:px-20"}></Experience>
        </div>
    </div>
    
  );
};

export default About;